import React from "react";

interface FeatureBadgeProps {
  text: string;
  link?: string; // Optional link prop
}

const FeatureBadge = ({ text, link }: FeatureBadgeProps) => (
  <a
    href={link}
    className="bg-cyan-600 rounded-full px-4 py-1.5 text-white flex items-center gap-2 text-sm hover:bg-cyan-700 transition-colors duration-200"
  >
    {/* Restored background, adjusted padding and added text-sm */}
    <div className="rounded-full px-4 py-1.5 text-white flex items-center gap-2 text-sm">
      {" "}
      {/* Restored background, adjusted padding and added text-sm */}
      {/* Assuming propertylk-cyan is the desired accent color. */}
      <span className="bg-propertylk-cyan rounded-full w-2 h-2"></span>
      {text}
    </div>
  </a>
);

export default FeatureBadge;
